import MTable from 'components/Table/Table'
import Mpopup from "components/Mpopup/Mpopup"
import 'vant/es/toast/style';
import Modal from "components/Modal/Modal"
import Region from "lib/region"
import util from "lib/util"
import wx from 'weixin-js-sdk'

export default {
  name: 'batchPrice',
  components: {
    MTable,
    Mpopup,
    Modal
  },
  created() {
    const paramsToken = util.query('token') || '' //路径携带了token
    this.sendxzq = util.query('sendxzq') || this.defaultxzq //没有寄件地址时使用默认地址
    this.recxzq = util.query('recxzq') || ''
    this.customerId = util.query('customerId') || ''
    this.source = util.query('source') || ''
    this.getProtocolInfo()
    util.loadScript("https://cdn.kuaidi100.com/js/share/jssdk/kuaidi100-jssdk.min.js", () => {
      if (typeof window.kuaidi100 == 'object') {
        const env = kuaidi100.getEnv()   
        const userAgent = window.navigator.userAgent.toLowerCase()
        const isWechat = /miniProgram/i.test(window.navigator.userAgent);
        this.env = isWechat ? 'wechat' : env
        console.log(this.env);
        this.getBatch4Band()
        if(isWechat) {
          // this.getwxConfig() //只使用微信跳转无需进行config配置
          if (paramsToken) {
            this.token = paramsToken
            console.log('路径携带token', this.token);
            
          }
        } else {
          // 一般小程序获取不了token，从路径里获取，app用 sdk 去获取
          if (paramsToken) {
            this.token = paramsToken
          } else {
            kuaidi100.getToken({
              success(token) {
                console.log(`获取到的token${token}`);
                this.token = token
              },
            })
          }
        }
      }
    })
  },
  data() {
    return {
      source: '',
      tableData: [
        // { toAddress: "天津", grads: '0-1单', firstPrice: 5.8, overPriceUnit: 2 },
        // { toAddress: "天津", grads: '2-5单', firstPrice: 5.7, overPriceUnit: 2 },
        // { toAddress: "天津", grads: '6-10单', firstPrice: 5.6, overPriceUnit: 2 },
        // { toAddress: "北京", grads: '0-1单', firstPrice: 6.8, overPriceUnit: 2.5 },
        // { toAddress: "北京", grads: '2-5单', firstPrice: 6.7, overPriceUnit: 2.5 },
        // { toAddress: "上海", grads: '0-1单', firstPrice: 7.5, overPriceUnit: 3 },
      ],
      tableColumns: [
        { title: '收件地址', prop: 'toAddress', align: 'center' },
        { title: '日梯度', prop: 'grads', align: 'center' },
        { title: '0-1单', prop: 'firstPrice', align: 'center' },
        { title: '续重/kg', prop: 'overPriceUnit', align: 'center' }
      ],
      companyList: [],
      // 自动合并的列属性
      mergeProps: ['toAddress'],
      sendxzq: '',
      recxzq: '',
      pickmode: 'sendxzq',
      defaultxzq: '广东省,深圳市,南山区',
      protocolInfo: '',
      showProtocol: false,
      token: '',
      env: '',
      currentSelectCom: {},
      isCityDimension: false, //是否城市维度
    };
  },
  computed: {
    showTableData() {
      if( !this.tableData.length ) {
        return false;
      } else {
        if (this.isCityDimension && !this.recxzq) {
          return false
        } else {
          return true
        }
      }
    }
  },
  mounted() {
    this.region = new Region({
      others: null,
      level: 2,
      value: ("").split(","),
      confirm: result => {
        var str = []
        for (let i = 0, len = result.length; i < len; i++) {
          result[i] && (result[i].name) && str.push(result[i].name)
        }
        if(this[this.pickmode] !== str.join(",")) {
          this[this.pickmode] = str.join(",")
          console.log(this[this.pickmode]);
          this.getBatch4Band()
        }
        
      },
    })
  },
  beforeDestroy() {
    this.region.hide()
  },
  methods: {
    handleSelectCompany(com) {
      if (com.kuaidiCom === this.currentSelectCom.kuaidiCom) return
      this.currentSelectCom = com
      this.getPriceList()
    },
    getwxConfig() {
      this.$http.get("/weixin/wxjsticketsign.do", {
        data: {
          url: location.href
        }
      }).then(res => {
        res = res.data
        // wx.config({
        //   debug: false,
        //   appId: 'wx6885acbedba59c14',
        //   timestamp: res.timestamp,
        //   nonceStr: res.nonceStr,
        //   signature: res.signature,
        //   jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", "hideMenuItems"]
        // })
        // wx.ready(function () {
        //   console.log(22)
        // });
      }).catch(() => {
        // alert(JSON.stringify(res))
      })
    },
    getProtocolInfo() {
      this.$http.get(`https://a.kuaidi100.com/crm/open/privacySetting/findByCondition?termId=900030001&termType=00`, {
        handleFail: false,
        handleLogin: false
      }).then(res => {
        if (res.data && res.data.length) {
          const info = res.data[0]
          this.protocolInfo = info?.note
        }
      })
    },
    getBatch4Band() { //获取可用的快递公司列表
      // const url = "/apicenter/order.do?method=availableCom4BrandBatch"
      // const params = {
      //   data: {
      //     saddrid: '',
      //     sendxzq: this.sendxzq,
      //     sendAddr: '',
      //     latitude: '',
      //     longitude: '',
      //     recList: this.getRecmanList(),
      //     openOnline: 'Y',
      //     apiversion: 23,
      //     token: this.token || '',
      //     platform: this.env === 'wechat' ? 'WEIXINAPP' : this.env,
      //   },
      //   handleLogin: false
      // }
      const url = "/apicenter/order.do?method=availableCompList"
      const params = {
        data: {
          sendxzq: this.sendxzq.split(",").join(""),
          recxzq: this.recxzq.split(",").join(""),
          customerId: this.customerId || '',
          weight: 1,
          source: 'queryPriceList',
          compOrderType: 2
        },
        handleLogin: false
      }
      this.$http.post(url, params).then((res) => {

        this.companyList = res.data
        if (this.companyList.length) {
          this.currentSelectCom = this.companyList[0]
          this.getPriceList()
        } else {
          this.$toast("暂无可用快递公司")
        }
      })
    },
    getPriceList() {
      const params = {
        data: {
          customerId: this.currentSelectCom.customerId,
          fromProvince: this.sendxzq.split(",")[0],
          fromCity: this.sendxzq.split(",")[1],
          toProvince: this.recxzq.split(",")[0] || '',
          toCity: this.recxzq.split(",")[1] || '',
          type: this.currentSelectCom.orderType,
          // source: 'queryPriceList'
          // token: this.token || '',
          // platform: this.env === 'wechat' ? 'WEIXINAPP' : this.env,
        },
        outside: true,
        handleLogin: false
      }
      this.$http.post("/apicenter/order.do?method=getBatchPriceList", params).then((res) => {
        if (res.status !== 200) {
          // this.$toast(res.message)
          this.tableData = []
          this.tableColumns = []
          this.isCityDimension = false
          return
        }
        this.isCityDimension = false
        this.tableData = res.data?.tableData || []
        this.tableColumns = res.data?.tableHeader || []
        if(this.tableData.length) {
          let isCityDimension = false
          this.tableData.forEach((item)=> {
            if(item.toAddress.includes('市')) {
              isCityDimension = true
            }
          })
          this.isCityDimension = isCityDimension
        }
        // this.tableColumns = [
        //   {'title': '收件地址', 'prop': 'toAddress'},
        //   {'title': '日梯度', 'prop': 'grads'},
        //   {'title': '0-1kg', 'prop': 'price_0'},
        //   {'title': '续重1kg', 'prop': 'price_1'},
        //   {'title': '1-3kg', 'prop': 'price_2'},
        //   {'title': '3-6kg', 'prop': 'price_3'},
        // ]
        // this.tableData = [
        //   {'price_0': '12', 'grads': '0-1单', 'price_1': '6', 'price_2': '15', 'price_3': '22', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '2-5单', 'price_1': '6', 'price_2': '18', 'price_3': '28', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '6-10单', 'price_1': '6', 'price_2': '20', 'price_3': '30', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '11-20单', 'price_1': '6', 'price_2': '23', 'price_3': '35', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '20单以上', 'price_1': '6', 'price_2': '25', 'price_3': '40', 'toAddress': '辽宁'},
        //   {'price_0': '12', 'grads': '0-1单', 'price_1': '6', 'price_2': '15', 'price_3': '22', 'toAddress': '广东'},
        //   {'price_0': '12', 'grads': '2-5单', 'price_1': '6', 'price_2': '18', 'price_3': '28', 'toAddress': '广东'},
        //   {'price_0': '12', 'grads': '6-10单', 'price_1': '6', 'price_2': '20', 'price_3': '30', 'toAddress': '广东'},
        //   {'price_0': '12', 'grads': '11-20单', 'price_1': '6', 'price_2': '23', 'price_3': '35', 'toAddress': '广东'},
        //   {'price_0': '12', 'grads': '20单以上', 'price_1': '6', 'price_2': '25', 'price_3': '40', 'toAddress': '广东'},
        // ]
        this.tableColumns.forEach(item => {
          item.align = 'center'
          item.width = '25%'
        });
        this.tableColumns[0].fixed = true
        this.tableColumns[1].fixed = true

      }).catch((err) => {
      })
    },
    navigateToBatch() {
      if (!this.env) return
      if (this.env !== 'wechat') {
        if (this.source === 'batch') {
          kuaidi100 && kuaidi100.close()
          return 
        } else {
          kuaidi100 && kuaidi100.navigate({
            ios: "batchOrder?selectIndex=2",
            android: "batch/placeorder",
          },
          )
        }
      } else {
        if(this.source === 'batch') {
          wx.miniProgram.navigateBack({
            delta: 1
          })
          return 
        } else {
          wx.miniProgram.navigateTo({
            url: '/pages/dispatch/batch'
          })
        }
        
      }
    },
    getRecmanList() {
      const recman = [
        {
          province: this.recxzq.split(",")[0] || '',
          city: this.recxzq.split(",")[1] || '',
          district: this.recxzq.split(",")[2] || '',
          addr: '',
          name: '',
          mobile: '',
          tel: '',
          orderData: {
            cargo: '日用品',
            cargoInput: '',
            cargoDesc: [],
            weight: 1,
          }
        }
      ]
      const list = recman
      let num = 0
      for (const i of list) {
        for (const k in i.orderData) {
          i[k] = i.orderData[k]
        }
        i.cargoDesc = i.orderData.cargoDesc?.join(',')
        // i.recxzq = `${i.province},${i.city},${i.district}`
        i.recxzq = i.xzqName
        i.recAddr = i.address
        i.recMobile = i.phone
        i.recTel = i.fixedPhone
        i.raddrid = i.id
        i.recName = i.name
        i.cargo = i.cargoInput ? i.cargoInput : i.cargo
        num = num + 1
      }
      return JSON.stringify(list)
    },
    // 显示省市区选择器
    showPicker: function(pickmode) {
      this.pickmode = pickmode
      this.region.show(this[pickmode].split(","))
    },
    // 自定义合并方法
    customSpanMethod({ row, column, rowIndex, columnIndex }){
      // 如果是第一列（收件地址）
      if (columnIndex === 0) {
        const currentValue = row.toAddress;
        
        // 计算向下合并的行数
        let rowspan = 1;
        let nextRow = rowIndex + 1;
        while (nextRow < this.tableData.length) {
          if (this.tableData[nextRow].toAddress === currentValue) {
            rowspan++;
            nextRow++;
          } else {
            break;
          }
        }
        
        // 如果不是第一个相同值的单元格，则不显示，即隐藏重复单元格
        if (rowIndex > 0 && this.tableData[rowIndex - 1].toAddress === currentValue) {
          return { rowspan: 0, colspan: 0 };
        }
        
        return { rowspan, colspan: 1 };
      }
      
      // 其他列不合并
      return { rowspan: 1, colspan: 1 };
    },
    displayXzq(xzq) {
      if (!xzq) return "请选择"
      return xzq.split(",").join("/")
    }
  },
  
}